"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failTest = failTest;
/**
 * The 'fail' function is gone (see https://github.com/facebook/jest/issues/11698)
 * This gets around the problem.
 *
 * **Note** the 'done' parameter is gone. You should use async/await instead.
 * @param reason
 */
function failTest(reason) {
  let message = reason;
  const {
    matcherResult
  } = reason || {};
  if (matcherResult) {
    ({
      message
    } = matcherResult);
  }
  if (typeof message === 'string' && message.startsWith('\u001b[2mexpect')) {
    console.error(message); // it's a jest error, so just print it out.
    throw new Error('The test failed');
  } else {
    throw new Error(typeof message === 'string' ? message : JSON.stringify(message, null, 2));
  }
}